export default __webpack_public_path__ + "fab3ac06ae31e4127573b72c2f81ce4d.ico";